import { render, staticRenderFns } from "./ProfileInput.vue?vue&type=template&id=b8aac652&"
import script from "./ProfileInput.vue?vue&type=script&lang=js&"
export * from "./ProfileInput.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInput.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports